export default __webpack_public_path__ + "static/media/002-merge.a4a30488.png";